import flatpickrOriginal from 'flatpickr'

/* reexported with a TS type because original module has default export */
export const flatpickr =
  flatpickrOriginal as unknown as typeof flatpickrOriginal.default
